import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  runAdhocBackup(vdcId, vappId, retentionObj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/backup';
    return this.http
      .post(url, JSON.stringify(retentionObj))
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/adhoc-backup/adhoc-backup.service.ts